import React, { useState } from 'react';
import { Upload, Input, Button, Space, message, Image } from 'antd';
import { UploadOutlined, LinkOutlined } from '@ant-design/icons';
import { uploadImageRequest } from '../services/cms/uploadServiceRequest';

/**
 * UploadImage component - cho phép upload file ảnh hoặc nhập URL trực tiếp.
 * Upload xong sẽ tự điền URL vào Form field.
 * 
 * Props:
 * - value: string (URL hiện tại, từ Form.Item)
 * - onChange: function (callback từ Form.Item)
 * - placeholder: string
 */
const UploadImage = ({ value, onChange, placeholder = 'URL ảnh' }) => {
  const [uploading, setUploading] = useState(false);

  const handleUpload = async (file) => {
    try {
      setUploading(true);
      const result = await uploadImageRequest(file);
      if (result?.url) {
        onChange?.(result.url);
        message.success('Upload thành công!');
      } else {
        message.error('Upload thất bại!');
      }
    } catch {
      message.error('Lỗi khi upload ảnh!');
    } finally {
      setUploading(false);
    }
    return false; // Prevent default upload behavior
  };

  return (
    <Space.Compact style={{ width: '100%' }}>
      <Input
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={placeholder}
        prefix={<LinkOutlined style={{ color: '#999' }} />}
        suffix={
          value ? (
            <Image
              src={value}
              alt="preview"
              width={20}
              height={20}
              style={{ objectFit: 'contain', cursor: 'pointer' }}
              preview={{ mask: false }}
              fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
            />
          ) : null
        }
      />
      <Upload
        showUploadList={false}
        beforeUpload={handleUpload}
        accept="image/*"
      >
        <Button icon={<UploadOutlined />} loading={uploading} type="primary" ghost>
          Upload
        </Button>
      </Upload>
    </Space.Compact>
  );
};

export default UploadImage;
